import ClientOAuth2 from "client-oauth2";
const createAuth = credentials => new ClientOAuth2(credentials);
export default createAuth;